import ElementContentPopupMaker from '@/components/sections/builder/elements/body/popup-maker/content';
import ContentPopupMaker from '@/components/sections/builder/elements/body/popup-maker/content/index';
import ImagePopupmaker from '@/components/sections/builder/elements/body/popup-maker/image';
import ElementSettingPopupMaker from '@/components/sections/builder/elements/body/popup-maker/setting';
import { PopupMakerElementDataType } from '@/components/sections/builder/elements/body/popup-maker/type';
import { DEFAULT_THEME_COLOR_SCHEME } from '@/components/sections/builder/theme/color';
import { Blocks } from 'lucide-react';

const defaultData: PopupMakerElementDataType = {
  name: 'Popup',
  layout: 'horizontal',
  size: 'medium',
  padding: 0,
  rounded: 0,
  colorSchemeSection: DEFAULT_THEME_COLOR_SCHEME,
  buttonCloseText: 'x',
  buttonCloseRounded: 0,
};

export const ElementPreviewIcon = Blocks;

const PopupMaker = {
  type: 'popup_maker',
  group: 'body',
  defaultData,
  Element: ElementContentPopupMaker,
  Setting: ElementSettingPopupMaker,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  defaultChilds: [ImagePopupmaker, ContentPopupMaker],
  childs: [ImagePopupmaker, ContentPopupMaker],
  maxEntries: 1,
};

export default PopupMaker;
